import PublicationTypes from "constants/publication-types";
import PublicationComponentType from "utilities/enumerations/publication-component-type";
import EnhancedContentChapterManifestsService from "utilities/services/enhanced-content/enhanced-content-chapter-manifests-service";

interface UseEnhancedContentManifestOptions {
    publicationComponent?: {
        type: PublicationComponentType;
        nfpaLabel?: string;
    };
    code?: string;
    edition?: string;
    publicationType?: PublicationTypes;
    isAdmin?: boolean;
    disabled?: boolean;
    externalId?: string;
}
const STALE_TIME = 5 * 60 * 1000; // 5 minutes

const useEnhancedContentManifest = (
    options: UseEnhancedContentManifestOptions
) => {
    const {
        publicationComponent,
        code,
        edition,
        publicationType,
        disabled,
        externalId,
    } = options;
    const shouldSkipChapterManifests =
        publicationComponent?.type === PublicationComponentType.Chapter &&
        publicationType === PublicationTypes.NEC;
    const hasManifestData =
        !!code &&
        !!edition &&
        !!publicationComponent?.nfpaLabel &&
        publicationComponent?.type != null;

    const enableManifestQuery =
        !disabled && hasManifestData && !shouldSkipChapterManifests;

    const { list: listEnhancedContentManifests } =
        EnhancedContentChapterManifestsService.useListQuery();
    const {
        data: enhancedContentManifests,
        isLoading: isManifestsLoading,
        refetch: refetchManifests,
    } = listEnhancedContentManifests(
        {
            code: code!,
            edition: edition!,
        },
        {
            publicationComponentType: publicationComponent?.type!,
            nfpaLabel: publicationComponent?.nfpaLabel!,
        },
        {
            enabled: enableManifestQuery,
            staleTime: STALE_TIME,
        }
    );
    const currentEnhancedContentManifest =
        enhancedContentManifests?.resultObjects.find(
            (element) => element.externalId === externalId
        ) ?? null;

    return {
        enhancedContentManifests,
        loadingEnhancedContentManifests: isManifestsLoading,
        refetchManifests,
        currentEnhancedContentManifest,
    };
};

export default useEnhancedContentManifest;
